// src/redux/actions/salesActions.js
import { FETCH_SALES_PERSONAS_REQUEST, FETCH_SALES_PERSONAS_SUCCESS, FETCH_SALES_PERSONAS_FAILURE } from '../../../../Constants/actionTypes';
import { fetchSalesPersonaHomepage } from '../../../../Constants/apiService'

// Fetch Sales Request Action
export const fetchSalesRequest = () => ({
    type: FETCH_SALES_PERSONAS_REQUEST,
});

// Fetch Sales Success Action
export const fetchSalesSuccess = (salesData) => ({
    type: FETCH_SALES_PERSONAS_SUCCESS,
    payload: salesData,
});

// Fetch Sales Failure Action
export const fetchSalesFailure = (error) => ({
    type: FETCH_SALES_PERSONAS_FAILURE,
    payload: error,
});

// Thunk Action Creator for Fetching Sales
export const fetchSales = () => {
    return async (dispatch, getState) => {
        dispatch(fetchSalesRequest());

        const state = getState();
        const accessToken = state.auth.accessToken; 


        try {
            const data = await fetchSalesPersonaHomepage(accessToken);
            console.log(data)
            dispatch(fetchSalesSuccess(data));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(fetchSalesFailure(errorMessage));
        }
    };
};
